
import AppDropdownProfile from '@/components/AppDropdownProfile.vue'
import MaintenanceAlert from '@/components/MaintenanceAlert.vue'
import SurveyPopup from '@/components/SurveyPopup.vue'

export default {
  name: 'ClassLayout',
  components: {
    MaintenanceAlert,
    AppDropdownProfile,
    SurveyPopup,
  },
  middleware: 'authentication',
  data() {
    return {
      name: '',
      img: '/img/standardUser.svg',
    }
  },
  computed: {
    user() {
      return this.$store.getters['credential/user']
    },
  },
  async created() {
    const response = await this.$axios.get('/api/v1/academic/customer')
    this.$store.commit('credential/setProfile', {
      name: response.data.name,
      email: response.data.email,
    })
    if (response.data.image) {
      const newImageURL = response.data.image
      this.img = newImageURL
      this.$store.commit('credential/updateImage', newImageURL)
    } else {
      this.$store.commit('credential/updateImage', this.img)
    }
  },
}
